import { SearchDesktopMapExperiment } from '@eventbrite/discover-utils';
import { useEnvContext } from '../../context';
import { useServerEnrolledStatsigExperiment } from '../../context/experiments/hooks';

export const useMapExperiment = () => {
    const envContext = useEnvContext();
    const isMobile = envContext?.env?.isMobile;

    const mapExperiment = useServerEnrolledStatsigExperiment<string>({
        name: SearchDesktopMapExperiment.name,
        paramName: SearchDesktopMapExperiment.paramName,
        defaultValue: SearchDesktopMapExperiment.values.control,
        enabled: !isMobile,
    });

    return mapExperiment.variant === SearchDesktopMapExperiment.values.variant;
};
